import React from 'react'
import { reduxForm } from 'redux-form'
import { generateValidation } from 'redux-form-validation'
import moment from 'moment'

import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

import BaseModal from '../base-modal'
import DatePicker from '../forms/datepicker'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

const validations = {
  startPeriod: {
    required: true
  },
  endPeriod: {
    required: true
  },
}

class WorkTrackerDatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
    }

    this.onStartDateChange = this.onStartDateChange.bind(this)
    this.onEndDateChange = this.onEndDateChange.bind(this)
  }

  onStartDateChange (value) {
    this.setState({ minDate: value.clone().add(1, 'day') })
    this.props.fields.startPeriod.onChange(value)
  }

  onEndDateChange (value) {
    this.setState({ maxDate: value.clone().subtract(1, 'day') })
    this.props.fields.endPeriod.onChange(value)
  }

  render() {
    const {
      fields: {
        startPeriod,
        endPeriod,
      },
      minDate,
      maxDate,

      handleClose,
      handleSubmit,
      modalTitle,
      submitting,
      submitButtonText,
      onChange
    } = this.props

    return (
      <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName='work-orders-create-container'
      >
          <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
            <ModalFormRow>
              <ModalFormBlock>
                <DatePicker
                  {...startPeriod}
                  className='date-picker'
                  placeholderText='Date'
                  dateFormat='MM/DD/YY'
                  minDate={minDate}
                  maxDate={moment(this.state.maxDate)}
                  onChange={this.onStartDateChange}
                />
              </ModalFormBlock>
            </ModalFormRow>
            <ModalFormRow>
              <ModalFormBlock>
                <DatePicker
                  {...endPeriod}
                  className='date-picker'
                  placeholderText='Date'
                  dateFormat='MM/DD/YY'
                  minDate={moment(this.state.minDate)}
                  maxDate={maxDate}
                  onChange={this.onEndDateChange}
                />
              </ModalFormBlock>
            </ModalFormRow>
            <ModalFormRow>
              <ModalFormBlock submitButton>
                <button type='submit' disabled={submitting}>{submitButtonText || 'Submit'}</button>
              </ModalFormBlock>
            </ModalFormRow>
          </ModalForm>
      </BaseModal>
    );
  }
}

export default reduxForm({
  form: 'filterDatePeriod',
  ...generateValidation(validations)
})(WorkTrackerDatePicker)



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-tracker-date-picker.js